import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';

const PromptControlsWrapper = styled(Dialog.Content)({
  marginTop: -8,
});

export default PromptControlsWrapper;
